import React from 'react'
import PropTypes from 'prop-types'
import Anchor from '../shared/anchor'
import DarkLogo from '../../assets/img/logo.png'
import WhiteLogo from '../../assets/img/white-logo.png'
import {LogoWrap} from './logo.stc'
import DarkLogo2x from '../../assets/img/logo-340x52.png'
import WhiteLogo2x from '../../assets/img/white-logo-340x52.png'

const Logo = props => {
    return (
        <LogoWrap {...props}>
            <Anchor path="/">
                <img src={DarkLogo} srcset={`${DarkLogo} 1x, ${DarkLogo2x} 2x`} alt="Logo" className="dark-logo"/>
                <img src={WhiteLogo} srcset={`${WhiteLogo} 1x, ${WhiteLogo2x} 2x`} alt="Logo" className="white-logo"/>
            </Anchor>
        </LogoWrap>
    )
}

Logo.propTypes = {
    transparentBG: PropTypes.bool
}

export default Logo
